'use client';
import { useState, useMemo, JSX } from 'react';
import { enrichPieData, calculateTotal } from '../utils/pieChartUtils';
import { createLabelRenderer } from '../utils/pieChartRenderers';
import type { PieDataItem } from '../utils/pieChartUtils';

interface UsePieChartReturn {
	activeIndex: number | undefined;
	enrichedData: PieDataItem[];
	total: number;
	labelRenderer: (props: any) => JSX.Element | null;
	handleItemHover: (index: number | undefined) => void;
}

export const usePieChart = (data: Array<{ name: string; value: number; color?: string }>): UsePieChartReturn => {
	const [activeIndex, setActiveIndex] = useState<number | undefined>(undefined);

	const enrichedData = useMemo(() => enrichPieData(data), [data]);

	const total = useMemo(() => calculateTotal(data), [data]);

	const labelRenderer = useMemo(() => createLabelRenderer(activeIndex), [activeIndex]);

	const handleItemHover = (index: number | undefined) => {
		setActiveIndex(index);
	};

	return {
		activeIndex,
		enrichedData,
		total,
		labelRenderer,
		handleItemHover,
	};
};
